import React, { useEffect, useState } from "react";
import logo from "../assets/Images/Visko_logo.png";

import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
const Navbar = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const handleToggle = () => {
    setIsNavOpen(!isNavOpen);
  };
  const location = useLocation();
  // Function to check if link is active
  const isActive = (link) => {
    if (link.startsWith("#") || link.startsWith("/#")) {
      // Hash links on homepage
      return location.hash === link.replace("/", "") &&
        location.pathname === "/"
        ? "active"
        : "";
    }
    return location.pathname === link ? "active" : "";
  };

  // Close mobile menu on route/hash change
  useEffect(() => {
    setIsNavOpen(false);
  }, [location]);

  return (
    <div className="">
      <header
        id="header"
        className={`header sticky-top ${isNavOpen ? "mobile-nav-active" : ""}`}
      >
        <div className="topbar d-flex align-items-center light-background">
          <div className="container d-flex justify-content-center justify-content-md-between">
            <div className="contact-info d-flex align-items-center">
              <i className="bi bi-envelope d-flex align-items-center">
                <a href="mailto:contact@example.com">info@visko.group</a>
              </i>
              <i className="bi bi-phone d-flex align-items-center ms-4">
                <span>+91 7828911470</span>
              </i>
            </div>
            <div className="social-links d-none d-md-flex align-items-center contact-info"></div>
          </div>
        </div>

        <div className="branding d-flex align-items-center">
          <div className="container position-relative d-flex align-items-center justify-content-between">

            {/* Logo */}
            <Link to="/" className="logo d-flex align-items-center">
              <img
                src={logo}
                alt="Visko Group"
                style={{ height: "32px", width: "auto" }}   // 🔽 logo size chhota
              />
              <h1
                className="sitename fw-bold mb-0 ms-2"
                style={{ fontSize: "12px" }}                // 🔽 text size kam + bold
              >
                Visko Group
              </h1>
            </Link>

            <nav
              id="navmenu"
              className={`navmenu ${isNavOpen ? "d-block" : "d-none d-lg-block"}`}
            >
              <ul>
                <li>
                  <Link to="/" className={isActive("/")} onClick={handleToggle}>
                    Home
                  </Link>
                </li>

                <li>
                  <HashLink
                    smooth
                    to="/#about"
                    className={isActive("/#about")}
                    onClick={handleToggle}
                  >
                    About
                  </HashLink>
                </li>

                <li>
                  <Link
                    to="/activity"
                    className={isActive("/activity")}
                    onClick={handleToggle}
                  >
                    Gallery
                  </Link>
                </li>


                <li>
                  <Link
                    to="/career"
                    className={isActive("/career")}
                    onClick={handleToggle}
                  >
                    Career
                  </Link>
                </li>

                <li>
                  <HashLink
                    smooth
                    to="/#services"
                    className={isActive("/#services")}
                    onClick={handleToggle}
                  >
                    Companies
                  </HashLink>
                </li>

                <li>
                  <HashLink
                    smooth
                    to="/#testimonials"
                    className={isActive("/#testimonials")}
                    onClick={handleToggle}
                  >
                    Testimonials
                  </HashLink>
                </li>

                <li>
                  <HashLink
                    smooth
                    to="/#contact"
                    className={isActive("/#contact")}
                    onClick={handleToggle}
                  >
                    Contact
                  </HashLink>
                </li>

                <li><Link to="/walk-in-interview"
                  className={isActive("/walk-in-interview")

                  } onClick={handleToggle}>Walk-in Interview
                </Link></li>
              </ul>

              <i
                className="bi bi-x mobile-nav-close d-lg-none"
                onClick={handleToggle}
              ></i>
            </nav>

            <i
              className={`mobile-nav-toggle d-lg-none ${isNavOpen ? "d-none" : ""
                } bi bi-list`}
              onClick={handleToggle}
            ></i>
          </div>
        </div>
      </header>
    </div>

  );
};

export default Navbar;
